import { useState, useEffect, useCallback } from "react";

import configEntzy from "components/config/ConfigEntzy";

export const useMainSections = (options = {}) => {
  const { user } = options;
  const [reloadKeys, setReloadKeys] = useState(configEntzy.APP_SECTIONS_MAP);

  const sectionReload = useCallback((sections) => {
    const newKeys = { ...configEntzy.APP_SECTIONS_MAP };
    for (let section of sections) {
      newKeys[section] = section + Date.now();
    }
    setReloadKeys(newKeys);
  }, []);

  // if user details change trigger all sections reload
  useEffect(() => {
    if (user && user.connected) {
      sectionReload(configEntzy.APP_SECTIONS_LIST);
    }
  }, [user, sectionReload]);

  return [reloadKeys, sectionReload];
};

// USAGE
// const [reloadKeys, sectionReload] = useMainSections({ user });
